import { useEffect, useMemo, useState } from "react";
import { ICurrencyType } from "../_types/currency";
import { getCurrencyDetails, getPricingConfig } from "../_utils/PricingUtils";


const useGiftCardCurrencyManager = ({
  inDashboard,
  settings,
  fulfillmentType
}: any) => {


  const [currency, setCurrency] = useState<ICurrencyType>({
    code: "",
    symbol: "",
    rate: 1,
    shop: "",
    active: "",
    country: "",
    isInternational: false,
    moneyFormat: "",
  });

  const [pricingConfig, setPricingConfig] = useState<any>(null);

  useEffect(() => {

    if (!settings) {
      return;
    }

    const currency           = getCurrencyDetails(settings, inDashboard);
    const pricingConfig      = getPricingConfig(fulfillmentType, currency);

    setCurrency(currency);
    setPricingConfig(pricingConfig);


  }, [fulfillmentType, settings]);

  
  const res = {
    currency,
    pricingConfig
  }

  return useMemo(() => res, [res]);

}

export default useGiftCardCurrencyManager;